import { ChangeEvent } from 'react'
import styles from './styles.module.css'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

interface IItemDropDown {
  label: string
  data: (string | number)[]
  value: string | number
  setValue: Function
  disabled: boolean
}

function ItemDropDown({
  label,
  data,
  value,
  setValue,
  disabled,
}: IItemDropDown) {
  function onChangeWrapper(
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const {
      target: { value: newValue },
    } = event
    setValue(newValue)
  }

  const menuItems = data.map((item, index) => {
    return (
      <MenuItem
        key={index}
        value={item}
        className={styles.dropDownOption}
      >
        {item}
      </MenuItem>
    )
  })

  return (
    <div>
      <TextField
        className={styles.dropDownSelect}
        label={label}
        select
        disabled={disabled}
        onChange={onChangeWrapper}
        value={value}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: 400,
                width: 100,
                fontFamily: '',
              },
            },
          },
        }}
      >
        {menuItems}
      </TextField>
    </div>
  )
}

export default ItemDropDown
